import React from 'react';

import axios from '../../services/axios'
import { withRouter } from 'react-router-dom'

import Header from './Header';
import Body from './Body';

// textos
import Texts from './Text'

class Home extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            form: { email: '', password: '' },
            images: {
                br: [
                    require('../../images/home/servicos/volta_redonda.png'),
                    require('../../images/home/servicos/queimados.png'),
                    require('../../images/home/servicos/barra_do_pirai.png'),
                    require('../../images/home/servicos/itanhaem.png'),
                    require('../../images/home/servicos/duque_de_caxias.png'),
                    require('../../images/home/servicos/itatiaia.png'),
                    require('../../images/home/servicos/japeri.png'),
                    require('../../images/home/servicos/mendes.png'),
                    require('../../images/home/servicos/porto_real.png'),
                    require('../../images/home/servicos/sao_manuel.png'),
                    require('../../images/home/servicos/petrobras.png'),
                    require('../../images/home/servicos/usimeca.png'),
                    require('../../images/home/servicos/gasbrasiliano.png'),
                    require('../../images/home/servicos/white_martins.png'),
                    require('../../images/home/servicos/ipmdc.png'),
                    require('../../images/home/servicos/observatorio.png'),
                    require('../../images/home/servicos/sul_fluminense.png'),
                    require('../../images/home/servicos/museu.png'),
                    require('../../images/home/servicos/vincol.png'),
                    require('../../images/home/servicos/boticario.png'),
                    require('../../images/home/servicos/poupe.png'),
                    require('../../images/home/servicos/subway.png'),
                    require('../../images/home/servicos/vivo.png'),
                    require('../../images/home/servicos/wizard.png'),
                ],

                us: [
                    require('../../images/home/servicos/creation_village.png'),
                    require('../../images/home/servicos/scs.png'),
                    require('../../images/home/servicos/florida_a_gosto.png'),
                ]
            },
            language: props.language,
            text: new Texts(props.language),
        }
        this.handleInputChange = this.handleInputChange.bind(this)
        this.imagesHandle = this.imagesHandle.bind(this)
        this.handleLanguage = props.handleLanguage.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.routeChange = this.routeChange.bind(this)
    }

    componentDidMount(){
        window.scrollTo(0, 0);
    }

    handleInputChange(e) {
        e.preventDefault()
        let form = Object.assign({}, this.state.form)
        form[e.target.name] = e.target.value
        this.setState({form})
    }

    login = async () => {
        try {
            const response = axios.post('/login', this.state.form)
        } catch(err) { console.error(err) }
    }

    imagesHandle = async () => {
        try {
            const response = axios.get('/imagens', { Authorization: this.state.token })
            this.setState({images: response.data})
        } catch(err) { console.error(err) }
    }

    handleChangeText(lang){
        this.handleLanguage(lang)
        this.setState({ text: new Texts(lang) })
    }

    routeChange(route) {
        let path = `/${route}`;
        this.props.history.push(path);
    }
    
    render() {

        return (
            <div>
                <Header text={this.state.text} handleInputChange={this.handleInputChange} 
                    handleLanguage={this.handleChangeText} login={this.login} language={this.state.language}  />
                <Body text={this.state.text} imagens={this.state.images}language={this.state.language} 
                    routeChange={this.routeChange} />
            </div>
        )
    }
}

export default withRouter(Home)